// Lista canónica de páginas de navegación configurables por congregación.
// Usada por AdminPanel.vue para pintar los checkboxes; debe coincidir con las
// keys hardcodeadas en los botones de Menu.vue y con ALLOWED_MENU_PAGE_KEYS
// en server/routes/congregation.js.
export const MENU_PAGES = [
  { key: 'salidas', label: 'Salidas', icon: 'pi pi-briefcase' },
  { key: 'enlacesSalidas', label: 'Enlaces', icon: 'pi pi-link' },
  { key: 'enlacesInformes', label: 'Informes de conductores', icon: 'pi pi-check-square' },
  { key: 'mapaTerritorios', label: 'Mapa', icon: 'pi pi-map' },
  { key: 'mapaCalor', label: 'Mapa de calor', icon: 'pi pi-th-large' },
  { key: 'listaTerritorio', label: 'Territorios', icon: 'pi pi-sitemap' },
  { key: 'estadisticas', label: 'Informe S-13', icon: 'pi pi-chart-line' },
  { key: 'rutas', label: 'Rutas', icon: 'pi pi-directions' },
  { key: 'tAsignados', label: 'Asignados', icon: 'pi pi-bookmark' },
  { key: 'estudiosTerritorio', label: 'Estudios', icon: 'pi pi-book' },
  { key: 'transporteTerritorio', label: 'Transporte', icon: 'pi pi-car' },
  { key: 'alojamientos', label: 'Alojamientos', icon: 'pi pi-home' },
  { key: 'gruposInvitados', label: 'Invitados', icon: 'pi pi-users' },
  { key: 'plantillasMensaje', label: 'Plantillas', icon: 'pi pi-comment' },
  { key: 'metadataEnlaces', label: 'Metadata', icon: 'pi pi-share-alt' },
  { key: 'userManagement', label: 'Usuarios', icon: 'pi pi-users' },
]
